import lang from './lang';
import util from './_utils';

const copy_panel = d3.select('.graphic__right.community'),
	container = copy_panel.select('.rp__content--chart');

let hed, dek, svg, g, bars, dots, text;

let outerW = null,
	outerH = null,
	margin = null,
	w = null,
	h = null,
	domainY = null;

const barHeight = 40;

let x, y;

const xAccessor = 'Percent',
	yAccessor = 'Group';

let step = 0,
	drawn = false;

const duration = {
	fast: 250,
	medium: 500,
	slow: 1000,
	reallySlow: 5000
};

const data = [{
		'Group': 'Among group runners',
		'Percent': .63
	},
	{
		'Group': 'Among solo runners',
		'Percent': .52
	}
];

function init() {
	step = 0;

	setup();
}

function next(index) {
	step = index + 1;

	if (step == 0) {
		draw();
	} else {
		end();
	};
}

function setup(resize = false) {
	outerW = container.node().offsetWidth;

	domainY = [...new Set(data.map(d => d[yAccessor]))];

	if (!resize) {
		hed = container.append('h5').attr('class', 'chart__hed').style('opacity', 0);
		dek = container.append('h6').attr('class', 'chart__dek').style('opacity', 0);
		svg = container.append('svg').attr('width', outerW).attr('height', 0);

		margin = {
			left: getLeftMargin(),
			right: 10,
			top: 10,
			bottom: 10
		};

		// draw();
	}
}

function draw() {
	drawn = true;
	outerH = domainY.length * barHeight;

	w = outerW - margin.right - margin.left;
	h = outerH - margin.top - margin.bottom;

	hed.html(d => lang.translateViz('community', `Step-1--chart__hed`)).transition().duration(duration.medium).style('opacity', 1);
	dek.html(d => lang.translateViz('community', `Step-1--chart__dek`)).transition().duration(duration.medium).style('opacity', 1);

	svg.transition()
		.duration(domainY.length * 100)
		.attr('height', outerH);

	g = svg.append('g')
		.attr('transform', `translate(${margin.left}, ${margin.top})`);

	x = d3.scaleLinear().rangeRound([0, w]).domain([0, d3.max(data, d => d[xAccessor])]).nice();
	y = d3.scaleBand().rangeRound([0, h]).domain(domainY).padding(0.1);

	bars = g.selectAll('.comm-bar--bar').data(data, d => d[yAccessor]);
	dots = g.selectAll('.comm-bar--dot').data(data, d => d[yAccessor]);
	text = g.selectAll('.comm-bar--label').data(data, d => d[yAccessor]);

	bars.enter()
		.append('rect').attr('class', 'comm-bar--bar')
		.attr('x', x(0)).attr('y', d => y(d[yAccessor]) + y.bandwidth() / 2 - 1)
		.attr('width', 0).attr('height', 2)
		.attr('fill', '#1F63F3')
		.transition().duration(duration.slow).delay((d, i) => i * 100)
		.attr('width', d => x(d[xAccessor]) - x(0));

	dots.enter()
		.append('circle').attr('class', 'comm-bar--dot')
		.attr('cx', x(0)).attr('cy', d => y(d[yAccessor]) + y.bandwidth() / 2).attr('r', 0)
		.style('fill', '#1F63F3')
		.transition().duration(duration.slow).delay((d, i) => i * 100)
		.attr('cx', d => x(d[xAccessor])).attr('r', 4)

	text.enter()
		.append('text').attr('class', 'comm-bar--label')
		.attr('x', x(0)).attr('y', d => y(d[yAccessor]) + y.bandwidth() / 2)
		.attr('dy', 4).attr('dx', 10)
		.style('fill', (d, i) => i === 0 ? '#1F63F3' : '#999999').style('text-anchor', 'end')
		.style('opacity', 0)
		.text(d => {
			const post = lang.getCurrentLang() == 'ja-JP' ? ' ' : ' - ';
			return lang.translateViz('community', `${yAccessor}--${d[yAccessor]}`) + post
		})
		.transition().duration(duration.slow).delay((d, i) => i * 100)
		.attr('dx', -10).style('opacity', 1);

	g.selectAll('.comm-bar--label')
		.append('tspan')
		.style('font-weight', (d, i) => i === 0 ? 600 : 200)
		.text(d => {
			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${Math.round(d[xAccessor] * 100)}${spacer}%`
		});
}

function resizeBars() {
	if (drawn) {
		svg = container.select('svg');
		hed = container.select('h5');
		dek = container.select('h6');

		outerH = domainY.length * barHeight;

		w = outerW - margin.right - margin.left;
		h = outerH - margin.top - margin.bottom;

		svg.transition()
			.duration(domainY.length * 100)
			.attr('height', outerH);

		g = svg.select('g')
			.attr('transform', `translate(${margin.left}, ${margin.top})`);

		x = d3.scaleLinear().rangeRound([0, w]).domain([0, d3.max(data, d => d[xAccessor])]).nice();
		y = d3.scaleBand().rangeRound([0, h]).domain(domainY).padding(0.1);

		bars = g.selectAll('.comm-bar--bar');
		dots = g.selectAll('.comm-bar--dot');
		text = g.selectAll('.comm-bar--label');

		bars.transition().duration(0)
			.attr('x', x(0)).attr('y', d => y(d[yAccessor]) + y.bandwidth() / 2 - 1)
			.attr('width', d => x(d[xAccessor]) - x(0));

		dots.transition().duration(0)
			.attr('cx', d => x(d[xAccessor])).attr('cy', d => y(d[yAccessor]) + y.bandwidth() / 2).attr('r', 4);

		text.transition().duration(0)
			.attr('x', x(0)).attr('y', d => y(d[yAccessor]) + y.bandwidth() / 2);
	}
}

function end() {
	if (drawn) {
		hed.transition().duration(duration.medium).style('opacity', 0);
		dek.transition().duration(duration.medium).style('opacity', 0);

		bars = g.selectAll('.comm-bar--bar').data([]);
		dots = g.selectAll('.comm-bar--dot').data([]);
		text = g.selectAll('.comm-bar--label').data([]);

		bars.exit()
			.transition().duration(duration.medium).delay((d, i) => i * 100)
			.attr('x', x(0)).attr('width', 0)
			.remove();

		dots.exit()
			.transition().duration(duration.medium).delay((d, i) => i * 100)
			.attr('x', x(0)).attr('r', 0)
			.remove();

		text.exit()
			.transition().duration(duration.medium).delay((d, i) => i * 100)
			.style('opacity', 0)
			.remove();

		drawn = false;
	}
}

function getLeftMargin(values) {
	const fakeTextWidths = [];

	const fakeTextValues = svg.selectAll('.fake-margin-text')
		.data(domainY)
		.enter()
		.append('text')
		.attr('x', -1000)
		.attr('y', -1000)
		.attr('visibility', 'hidden')
		.text(d => {
			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${lang.translateViz('community', yAccessor+'--'+d)} - 1000${spacer}%`
		})
		.each(function() {
			fakeTextWidths.push(d3.select(this).node().getComputedTextLength());
		});

	fakeTextValues.remove();

	return d3.max(fakeTextWidths);
}


export default {
	init,
	setup,
	next,
	resizeBars,
	end
}